(() => {
  const initTrack = (track) => {
    if (track.dataset.bound) return;
    track.dataset.bound = '1';
    const root = track.closest('a.product-card__link') || track.closest('.product-card');
    const cardLink = track.closest('a.product-card__link');
    const segments = root ? root.querySelectorAll('.product-card__progress-segment') : [];
    let startX = 0;
    let moved = false;

    const update = () => {
      if (!segments.length) return;
      const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      segments.forEach((seg, i) => seg.classList.toggle('is-active', i === index));
    };

    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener(
      'pointerdown',
      (e) => {
        startX = e.clientX;
        moved = false;
      },
      { passive: true }
    );
    track.addEventListener(
      'pointermove',
      (e) => {
        if (Math.abs(e.clientX - startX) > 8) moved = true;
      },
      { passive: true }
    );

    if (cardLink) {
      cardLink.addEventListener('click', (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }

    segments.forEach((seg, i) => {
      seg.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      });
    });
  };

  const observe = () => {
    const tracks = document.querySelectorAll('.product-card__media-track');
    if (!tracks.length) return;
    if (!('IntersectionObserver' in window)) {
      tracks.forEach(initTrack);
      return;
    }
    const io = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          initTrack(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '200px 0px' }
    );
    tracks.forEach((track) => io.observe(track));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('product-card:media:refresh', observe);
})();
